<template>
  <div class="page cert-page">
    <xh-header />

    <div class="container-width" v-if="loaded">
      <!-- 未完成 / 不符合发证条件 -->
      <div v-if="!eligible" class="empty-block">
        <i class="el-icon-warning-outline"></i>
        <p>本课程尚未完成（需看完全部视频并通过考试），暂不可获取培训证书。</p>
        <div style="margin-top:16px;">
          <el-button type="primary" size="small" @click="back">返回课程</el-button>
        </div>
      </div>

      <!-- 证书展示 -->
      <div v-else class="cert-wrap">
        <!-- 面包屑返回（与其它学习中心页面统一的文字链接风格） -->
        <div class="crt-bread">
          <span class="mouse" @click="back">
            <i class="el-icon-arrow-left"></i> 返回课程
          </span>
        </div>

        <!-- 成就横幅（与课程详情页证书横幅风格一致） -->
        <div class="crt-banner">
          <div class="cb-icon"><i class="el-icon-medal"></i></div>
          <div class="cb-text">
            <div class="cb-title">恭喜完成《{{ course.courseName }}》</div>
            <div class="cb-sub">您已看完全部视频并通过考试，特颁发培训结业证书，可保存到本地留存。</div>
          </div>
          <el-button type="primary" :loading="rendering" @click="download" class="cb-btn">
            <i class="el-icon-download"></i> 保存到本地
          </el-button>
        </div>

        <!-- 证书本体（用于 html2canvas 截图） -->
        <div class="cert-stage">
          <div class="a-pic" ref="imageWrapper">
            <div class="wrapper">
              <div class="cert-title">培 训 结 业 证 书</div>
              <div class="t1">经协会审核认定：</div>
              <div class="h3">
                <b>{{ name }}</b>&nbsp;同志完成了
                <br />
                《<b>{{ course.courseName }}</b>》
                <br />
                课程的全部视频学习与考核，成绩合格
              </div>
              <div class="t2">特发此证</div>
              <div class="logo">
                <img :src="logoImg" />
              </div>
              <div class="z">
                <img :src="sealImg" />
              </div>
              <div class="mun">
                <span class="n1">证书编号: {{ certNo }}</span>
                <span class="n2">签发日期: {{ issueDateText }}</span>
                <span class="n3">有效期至: {{ expireDateText }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 预览图（html2canvas 生成后展示，保存即用此 dataURL） -->
        <div class="cert-preview" v-if="ticketPic">
          <div class="pv-label">证书预览</div>
          <img :src="ticketPic" />
        </div>
      </div>
    </div>

    <xh-footer />
  </div>
</template>

<script>
import XhHeader from '../../../reveals/xh-header.vue'
import XhFooter from '../../../reveals/xh-footer.vue'
import html2canvas from 'html2canvas'
import {
  getStudyCourseDetail,
  getStudyVideoList,
  getStudyUserPassStatus,
  getStudyWatchPage
} from '@/service/apis/study'

// 证书底图/印章/Logo（require 确保 webpack 处理为真实 URL，便于 html2canvas 抓取）
const BG_IMG = require('@/assets/images/bg.jpg')
const LOGO_IMG = require('@/assets/images/logo__1.png')
const SEAL_IMG = require('@/assets/images/z.png')

// 默认有效期：自签发日起 1 年（若课程 endTime 更晚则取课程结束时间）
const ONE_YEAR_MS = 365 * 24 * 3600 * 1000

export default {
  name: 'StudyCertificate',
  components: { XhHeader, XhFooter },
  data () {
    return {
      account: null,
      courseId: null,
      course: null,
      passStatus: null,
      watchedNum: 0,
      totalVideoNum: 0,
      loaded: false,
      eligible: false,
      rendering: false,
      ticketPic: '',
      bgImg: BG_IMG,
      logoImg: LOGO_IMG,
      sealImg: SEAL_IMG
    }
  },
  computed: {
    name () {
      return (this.account && this.account.name) || '学员'
    },
    // 签发日期 = 考试通过时间；无则取当前
    issueTs () {
      const t = this.passStatus && this.passStatus.lastSubmitTime
      return t ? Date.parse(t) : Date.now()
    },
    issueDateText () {
      return this.formatDot(this.issueTs)
    },
    // 有效期至：课程 endTime（更晚时优先），否则签发日 +1 年
    expireTs () {
      const end = this.course && this.course.endTime
        ? Date.parse(this.course.endTime)
        : 0
      const oneYear = this.issueTs + ONE_YEAR_MS
      return end > oneYear ? end : oneYear
    },
    expireDateText () {
      return this.formatDot(this.expireTs)
    },
    certNo () {
      const pad = (n, len = 4) => String(n).padStart(len, '0')
      const accId = (this.account && this.account.id) || 0
      const ymd = this.formatCompact(this.issueTs)
      return `PX${ pad(this.courseId) }${ pad(accId) }${ ymd }`
    }
  },
  created () {
    const cid = this.$route.query.courseId
    if (!cid) {
      this.$message.error('参数缺失')
      this.$router.replace('/userinfo')
      return
    }
    this.courseId = Number(cid)
    const acct = localStorage.getItem('ACCOUNT')
    if (!acct) {
      this.$router.replace('/login')
      return
    }
    this.account = JSON.parse(acct)
    this.loadAll()
  },
  methods: {
    handle9994 (res) {
      if (res && res.errCode === 9994) {
        localStorage.clear()
        this.$router.replace('/login')
        return true
      }
      return false
    },
    formatDot (ts) {
      if (!ts) return '--'
      return this.formatDate(ts, 'YYYY.mm.dd')
    },
    formatCompact (ts) {
      const d = new Date(ts)
      const pad = n => String(n).padStart(2, '0')
      return `${ d.getFullYear() }${ pad(d.getMonth() + 1) }${ pad(d.getDate()) }`
    },
    loadAll () {
      const tasks = []
      // 课程详情
      tasks.push(getStudyCourseDetail.call(this, { id: this.courseId }).then(res => {
        if (this.handle9994(res)) return
        if (res.errCode === 0) this.course = res.data
      }))
      // 视频清单 → 总数
      tasks.push(getStudyVideoList.call(this, { courseId: this.courseId, pageIndex: 1, pageSize: 1000 }).then(res => {
        if (this.handle9994(res)) return
        if (res.errCode === 0 && res.data) {
          const list = Array.isArray(res.data) ? res.data : (res.data.records || [])
          this.totalVideoNum = list.length
        }
      }))
      // 已看视频 → 已看数
      tasks.push(getStudyWatchPage.call(this, {
        accountId: this.account.id,
        courseId: this.courseId,
        pageIndex: 1,
        pageSize: 1000
      }).then(res => {
        if (this.handle9994(res)) return
        if (res.errCode === 0 && res.data && Array.isArray(res.data.records)) {
          this.watchedNum = res.data.records.filter(r => r.finishFlag === 1 || r.finishFlag === undefined).length
        }
      }))
      // 考试通过状态
      tasks.push(getStudyUserPassStatus.call(this, { accountId: this.account.id }).then(res => {
        if (this.handle9994(res)) return
        if (res.errCode === 0 && Array.isArray(res.data)) {
          this.passStatus = res.data.find(s => s.courseId === this.courseId) || null
        }
      }))

      Promise.all(tasks).then(() => {
        const videoDone = this.totalVideoNum === 0 ? true : this.watchedNum >= this.totalVideoNum
        const examDone = this.passStatus && this.passStatus.latestPassFlag === 1
        // 必须同时有视频和考试（避免空课程也发证）
        this.eligible = videoDone && examDone && (this.totalVideoNum > 0)
        this.loaded = true
        if (this.eligible) {
          this.$nextTick(() => this.render())
        }
      })
    },
    render () {
      const el = this.$refs.imageWrapper
      if (!el) return Promise.resolve()
      this.rendering = true
      return html2canvas(el, {
        useCORS: true,
        backgroundColor: null,
        scale: 2
      }).then(canvas => {
        this.ticketPic = canvas.toDataURL('image/png')
        this.rendering = false
      }).catch(() => {
        this.rendering = false
        this.$message.error('证书生成失败，请重试')
      })
    },
    download () {
      if (this.ticketPic) {
        this.triggerDownload()
        return
      }
      if (this.rendering) {
        this.$message.info('证书生成中，请稍候')
        return
      }
      this.render().then(() => {
        if (this.ticketPic) this.triggerDownload()
      })
    },
    triggerDownload () {
      const a = document.createElement('a')
      a.href = this.ticketPic
      a.download = `${ this.course.courseName }-培训证书.png`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      this.$message.success('证书已开始下载')
    },
    back () {
      this.$router.push('/study/course?id=' + this.courseId)
    }
  }
}
</script>

<style scoped>
.cert-page { background: #fff; }
.container-width { padding: 24px 0 60px; min-height: 60vh; }

.cert-wrap { max-width: 760px; margin: 0 auto; }

/* 面包屑返回 */
.crt-bread {
  font-size: 13px;
  color: #888;
  padding: 4px 0 14px;
}
.crt-bread .mouse:hover { color: #4c2ac9; }

/* 成就横幅（与课程详情页证书横幅统一） */
.crt-banner {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 22px;
  border-radius: 10px;
  background: linear-gradient(135deg, #fff8e6 0%, #fff3d6 100%);
  border: solid 1px #ffe2a8;
  margin-bottom: 20px;
}
.crt-banner .cb-icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #f0a020;
  box-shadow: 0 2px 8px rgba(240, 160, 32, .2);
}
.crt-banner .cb-text { flex: 1; min-width: 0; }
.crt-banner .cb-title {
  font-size: 16px;
  font-weight: 600;
  color: #8a5a00;
  line-height: 24px;
}
.crt-banner .cb-sub {
  font-size: 12px;
  color: #b3822e;
  margin-top: 4px;
  line-height: 18px;
}
.crt-banner .cb-btn { flex-shrink: 0; }

/* 截图舞台：隐藏在视口外，但仍参与布局以便 html2canvas 抓取 */
.cert-stage {
  position: fixed;
  left: -10000px;
  top: -10000px;
  width: 600px;
  height: 425px;
}
.a-pic {
  width: 600px;
  height: 425px;
  background: url('~@/assets/images/bg.jpg') center center no-repeat;
  background-size: cover;
}
.a-pic .wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 12px;
  box-sizing: border-box;
}
.cert-title {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 4px;
  color: #b00;
  padding-top: 34px;
}
.a-pic .t1 {
  text-align: left;
  font-size: 14px;
  padding: 14px 0 8px 44px;
  color: #333;
}
.a-pic .h3 {
  line-height: 34px;
  font-size: 20px;
  text-align: center;
  color: #222;
}
.a-pic .h3 b { color: #b00; }
.a-pic .t2 {
  font-size: 18px;
  padding-top: 18px;
  text-align: center;
  letter-spacing: 2px;
  color: #333;
}
.a-pic .mun {
  position: relative;
  font-size: 12px;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 36px;
  color: #4c4f4d;
}
.a-pic .mun span {
  padding: 0 12px 6px 12px;
  border-bottom: solid 1px #4c4f4d;
}
.a-pic .logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 44px;
}
.a-pic .logo img { width: 92px; }
.a-pic .z {
  position: absolute;
  right: 48px;
  bottom: 52px;
  z-index: 10;
}
.a-pic .z img { width: 92px; }

.cert-preview {
  margin-top: 8px;
  text-align: center;
}
.cert-preview .pv-label {
  font-size: 13px;
  color: #999;
  margin-bottom: 8px;
}
.cert-preview img {
  max-width: 100%;
  border: solid 1px #eee;
  border-radius: 6px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, .08);
}

.empty-block {
  text-align: center;
  color: #999;
  padding: 80px 20px;
  font-size: 14px;
}
.empty-block i { font-size: 48px; color: #ddd; display: block; margin-bottom: 12px; }

@media screen and (max-width: 800px) {
  .container-width { padding: 12px 16px 30px; }
  .crt-banner {
    flex-wrap: wrap;
    padding: 14px 16px;
    gap: 12px;
  }
  .crt-banner .cb-title { font-size: 15px; }
  .crt-banner .cb-btn { width: 100%; }
  .crt-banner .cb-btn >>> span,
  .crt-banner .cb-btn ::v-deep span { width: 100%; }
}
</style>
